@if (hasItems()) {
<mat-toolbar class="minimized-bar">
    <button matButton="text" type="button" (click)="closeAll()" class="close-all-button"
        [matTooltip]="'Close all minimized items'" matTooltipPosition="above">
        <mat-icon>close</mat-icon>
        <span>Close All</span>
    </button>
    <div class="minimized-items-container">
        @for (item of items(); track item.id) {
        <button [matButton]="item.isVisible ? 'filled' : 'tonal'" (click)="restore(item.id)"
            [class.restored-item]="item.isVisible" class="minimized-item-button">
            <span>{{ item.title }}</span>
            <button mat-icon-button type="button" (click)="close(item.id, $event)" class="close-button"
                [matTooltip]="'Close ' + item.title" matTooltipPosition="above" tabindex="-1">
                <mat-icon>close</mat-icon>
            </button>
        </button>
        }
    </div>
</mat-toolbar>
}
